export const CATEGORIES_TYPES = {
    GET_CATEGORIES: 'GET_CATEGORIES',
}